export default {
    // to: "/dashboard/products/ipn",
    // order: 3,
    // icon: "mdi-notification-clear-all",
    // title: "Instant Payment Notification",
    // disabled: false,
    // value: 0,
}
